import React, {useState, useEffect} from "react";
import Multiselect from 'multiselect-react-dropdown';

const Location = (props) => {
    const[selectedValues, setSelectedValues] = useState(props.filters)

    const ref = React.createRef()

    const onSelect = (selectedList, selectedItem) => {
        setSelectedValues(selectedList)
        props.callbackFunction("Site", selectedList);
    }

    const onRemove = (selectedList, removedItem) => {
        setSelectedValues(selectedList)
        props.callbackFunction("Site", selectedList);
    }

    useEffect(() => {
        setSelectedValues(props.filters)
    },[props.filters])

    let options = (props.searchResults && props.searchResults.filter(r => r.context === "site")) || []

    return (
        <div className="subsearch-element">
        <Multiselect key={props.filters && props.filters.length} style={{multiselectContainer: {borderColor: "#003e51"}}}
            options={options} // Options to display in the dropdown
            selectedValues={selectedValues} // Preselected value to persist in dropdown
            onSelect={onSelect} // Function will trigger on select event
            onRemove={onRemove} // Function will trigger on remove event
            displayValue="name" // Property name to display in the dropdown options
            placeholder="Locations"
            showArrow={true}
            showCheckbox={true}
            avoidHighlightFirstOption={true}
            closeOnSelect={false}
            ref={ref}
        />

        </div>
    )

}

export default Location;